export const PLATFORMS = [
  { key: 'ig',        label: 'Instagram',  short: 'IG',  color: '#E55D4A' },
  { key: 'moj',       label: 'Moj',        short: 'MOJ', color: '#F2951B' },
  { key: 'snapchat',  label: 'Snapchat',   short: 'SNAP',color: '#D8E04D' },
  { key: 'reddit',    label: 'Reddit',     short: 'RED', color: '#E55D4A' },
  { key: 'yt',        label: 'YouTube',    short: 'YT',  color: '#E55D4A' },
  { key: 'linkedin',  label: 'LinkedIn',   short: 'LI',  color: '#2C7CE5' },
  { key: 'twitter',   label: 'Twitter/X',  short: 'X',   color: '#2C7CE5' },
];

export const TIERS  = ['Barter','Nano','Micro','Macro'];

export const NICHES = [
  'Mom','Fashion','Tech','Fitness','Food','Travel','Lifestyle',
  'Beauty','Gaming','Finance','Education','Entertainment','Healthcare','Explore','Other',
];

export const LANGUAGES = [
  'Hindi','English','Tamil','Telugu','Bengali','Marathi','Gujarati',
  'Kannada','Malayalam','Punjabi','Odia','Urdu','Assamese','Maithili',
];

export const DELIVERABLES = [
  'Reels','Stories','Static Post','Carousel','YouTube Video',
  'YouTube Shorts','Live','Blog','Podcast','UGC',
];

export const BRAND_FIT = ['Y','N',''];

// Chord Brand Colors
export const CHORD = {
  // Core Base
  beige:      '#F5EBDD',
  sand:       '#EADCC3',
  charcoal:   '#2B2B2B',
  softBlack:  '#1A1A1A',
  // Vibrant Accents
  lime:       '#D8E04D',
  coral:      '#E55D4A',
  azure:      '#2C7CE5',
  orange:     '#F2951B',
  // Derived UI
  bg:         '#1A1A1A',      // main background
  bgCard:     '#242420',      // card background
  bgPanel:    '#2B2B27',      // panel / filter bar
  border:     'rgba(245,235,221,0.1)',
  borderHover:'rgba(245,235,221,0.22)',
  textPrimary:'#F5EBDD',
  textMuted:  'rgba(245,235,221,0.5)',
  textFaint:  'rgba(245,235,221,0.25)',
};

export const TIER_COLORS = {
  Barter: '#F2951B',
  Nano:   '#D8E04D',
  Micro:  '#2C7CE5',
  Macro:  '#E55D4A',
};

export function fmtK(n) {
  if (!n && n !== 0) return '—';
  if (n >= 10000000)  return (n/10000000).toFixed(1).replace(/\.0$/,'') + 'Cr';
  if (n >= 100000)    return (n/100000).toFixed(1).replace(/\.0$/,'') + 'L';
  if (n >= 1000)      return (n/1000).toFixed(1).replace(/\.0$/,'') + 'K';
  return String(n);
}

export function fmtPct(n) {
  if (!n) return '—';
  return (n * 100).toFixed(2) + '%';
}

export function fmtRate(n) {
  if (!n) return '—';
  return '₹' + Number(n).toLocaleString('en-IN');
}

export function parseTags(str) {
  if (!str) return [];
  return str.split(',').map(s => s.trim()).filter(Boolean);
}

export function joinTags(arr) {
  return arr.filter(Boolean).join(', ');
}

export const COLORS = [
  '#E55D4A','#2C7CE5','#D8E04D','#F2951B',
  '#EADCC3','#7FB5F5','#F2A58E','#B5D455',
  '#F5C842','#90C8F0',
];

// Shared theme styles using Chord palette
export const S = {
  page: {
    minHeight:'100vh',
    background: '#1A1A1A',
    color: '#F5EBDD',
    fontFamily: "'Montserrat', sans-serif",
  },
  card: {
    background: '#242420',
    border: '0.5px solid rgba(245,235,221,0.1)',
    borderRadius: 14,
    padding: '1.25rem 1.5rem',
  },
  inp: {
    background: 'rgba(245,235,221,0.06)',
    border: '0.5px solid rgba(245,235,221,0.15)',
    borderRadius: 8,
    padding: '9px 13px',
    fontSize: 14,
    color: '#F5EBDD',
    outline: 'none',
    fontFamily: "inherit",
    width: '100%',
  },
  lbl: {
    fontSize: 12,
    color: 'rgba(245,235,221,0.5)',
    marginBottom: 4,
    display: 'block',
    letterSpacing: '0.3px',
  },
  sec: {
    fontSize: 11,
    fontWeight: 600,
    color: 'rgba(245,235,221,0.35)',
    textTransform: 'uppercase',
    letterSpacing: '1.2px',
    margin: '1.5rem 0 0.8rem',
  },
  btnPrimary: {
    background: '#E55D4A',
    border: 'none',
    borderRadius: 8,
    padding: '9px 22px',
    fontSize: 13,
    fontWeight: 600,
    color: '#F5EBDD',
    cursor: 'pointer',
    fontFamily: 'inherit',
    letterSpacing: '0.3px',
  },
  btnSecondary: {
    background: 'rgba(245,235,221,0.07)',
    border: '0.5px solid rgba(245,235,221,0.18)',
    borderRadius: 8,
    padding: '9px 22px',
    fontSize: 13,
    color: 'rgba(245,235,221,0.6)',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};

// Auto-calculate tier from followers
export function tierFromFollowers(followers) {
  const f = parseInt(followers) || 0;
  if (f <= 0)       return 'Barter';
  if (f <= 8000)    return 'Barter';
  if (f <= 20000)   return 'Nano';
  if (f <= 100000)  return 'Micro';
  return 'Macro';
}
